APP.Settings = (/** @lends APP.Settings */function () {
	'use strict';

	var exports,
		$body;

	function init() {

		initDOMElements();
		initBindings();

		defineMustCheckGroup(
			'[data-ctn-privacy="CustomerSatisfactionSurveySms"], [data-ctn-privacy="CustomerSatisfactionSurveyOnline"]',
			'[data-ctn-privacy="CustomerSatisfactionSurvey"]'
		);

		checkForSocialRegistration();
		$body.change(function () {
			console.log('ready');
		});
	}

	function initDOMElements() {
		$body = APP.Performance.getCachedDOM().$body;
	}

	function initBindings() {
		APP.Bind.click({
			'toggle-edit-bloc': toggleEditBlock,
			'email-register-ctn': emailRegisterCtn,
			'ctn-settings-reset': ctnSettingsReset,
			'save-privacy-settings': savePrivacySettings,
			'remove-email-value-disable': removeEmailValueDisable,
			'add-email-value-disable': addEmailValueDisable,
			'handle-email-helper-dropdown': handleEmailHelperDropdown,
			'consent-set-default-email': consentSetDefaultEmail
		});

		APP.Bind.change({
			'save-ca-settings': saveCASettings,
			'save-notification-settings': saveNotificationSettings
		});

		APP.Bind.blur({
			'change-nickname': function (event, arg) {
				APP.Service.post({'ctn-or-ca': window.parseJSON(arg).id, nickname: $(event.currentTarget).val()}, $body.find('[data-save-nick]').val());
			}
		});

		$body.on('change', '[data-ctn-select]', function () {
			$body.find('[data-ctn-tab]').css('display', 'none');
			$body.find('[data-ctn-tab="' + $(this).val() + '"]').attr('style', '');
		});

		$body.on('change', '[data-only-checked]', function () {
			var dependerNames = $(this).attr('data-only-checked').split(';'),
				$dependers = $body.find('[data-element="' + dependerNames.join('"], [data-element="') + '"]');

			if (!$(this).prop('checked')) {
				$dependers.addClass('tr--disabled');
				$dependers.find('.checkbox--wrapper').addClass('checkbox--wrapper--disabled');
				$dependers.find('input').prop('checked', false);
			} else {
				$dependers.removeClass('tr--disabled');
				$dependers.find('.checkbox--wrapper').removeClass('checkbox--wrapper--disabled');
				$dependers.find('input').first().prop('checked', true);
			}

		});

	}

	function defineMustCheckGroup(selection, parentCheckboxSelection) {
		$body.on('change', selection + ',' + parentCheckboxSelection, function () {
			var checked = false,
				$checkbox = $(this);

			$body.find(selection).each(function () {
				var $this = $(this);

				if ($this.is('checked')) {
					checked = true;
				}
			});

			if (!checked && $body.find(parentCheckboxSelection).prop('checked')) {
				$body.find(selection).not($checkbox).first().prop('checked', true);
			}

		});

	}

	function checkForSocialRegistration() {
		var type;

		$body.find('[data-registered-social]').each(function () {
			type = $(this).attr('data-registered-social').toLowerCase();

			switch (type) {
			case 'facebook':
				APP.Analytics.trackEvent('Account', 'Connect', 'Facebook');
				break;
			case 'google':
				APP.Analytics.trackEvent('Account', 'Connect', 'Google');
				break;
			case 'apple':
				APP.Analytics.trackEvent('Account', 'Connect', 'Apple');
				break;
			}

		});

	}

	function toggleEditBlock(e, id) {
		$body.find('[data-simple="' + id + '"]').toggleClass('hidden');
		$body.find('[data-edit="' + id + '"]').toggleClass('hidden');
		e.preventDefault();
	}

	function savePrivacySettings() {
		$body.find('[data-ctn-settings-wrapper]').addClass('sc-form--loading');
		APP.Service.post({
			ctn: $body.find('[data-ca]').val(),
			values: getPrivacySettingsObject()
		}, $body.find('[data-save-consent-settings-url]').val()).then(function (result) {
			if (result.errors._global) {
				APP.Layout.alert(result.errors._global, 'Hiba');
			} else {
				$body.find('[data-ref~="privacy-settings-save-btn"]').attr('disabled', 'disabled').addClass('button--disabled');
			}

			$body.find('[data-ctn-settings-wrapper]').removeClass('sc-form--loading');
			if (!result.data.validPrivacySettings) {
				APP.Overlay.openWithTpl('not-valid-privacy', {message: result.errors._global});
			}
		});

	}

	function getPrivacySettingsObject() {
		var object = {};

		$body.find('[data-privacy-setting-row]').each(function () {
			var $settingRow = $(this),
				$selectedInput = $settingRow.find('input[type="radio"]:checked:not([disabled])'),
				$additionalInput = $settingRow.find('[data-privacy-setting-additional]'),
				ctnPrefix = null,
				ctnInput = null,
				emailInput = null
			;

			if ($selectedInput.length > 0) {
				object[$selectedInput.attr('name')] = {
					name: $selectedInput.attr('name'),
					action: $selectedInput.val() === 'true' ? 'accept' : 'decline'
				};

				if ($additionalInput.attr('data-privacy-setting-additional') === 'phone-number') {
					object[$selectedInput.attr('name')]['given-contact-data-type'] = $additionalInput.attr('data-privacy-setting-additional');

					if ($additionalInput.length > 0) {
						ctnPrefix = $additionalInput.find('[data-selectric] option:selected').val();
						ctnInput = $additionalInput.find('[data-ref~="ctn-input"]').val();
						if (ctnInput.length > 0) {
							object[$selectedInput.attr('name')]['given-contact-data'] = ctnPrefix + ctnInput;
						}
					}
				}

				if ($additionalInput.attr('data-privacy-setting-additional') === 'phone-number-hidden') {
					object[$selectedInput.attr('name')]['given-contact-data-type'] = $additionalInput.attr('data-privacy-setting-additional');
				}

				if ($additionalInput.attr('data-privacy-setting-additional') === 'email') {
					object[$selectedInput.attr('name')]['given-contact-data-type'] = $additionalInput.attr('data-privacy-setting-additional');
					emailInput = $additionalInput.find('[data-ref~="email-input"]').val();
					if ($additionalInput.length > 0 && emailInput.length > 0) {
						object[$selectedInput.attr('name')]['given-contact-data'] = emailInput;
					}
				}
			}
		});

		return object;
	}

	function saveCASettings(e, key) {
		var ctnSelectVal = $body.find('[data-ctn-select]').val(),
			sendData = {
				caid: $body.find('[data-caid]').val()
			};

		sendData[key] = $(e.target).prop('checked');

		if (ctnSelectVal.length > 0) {
			sendData.ctn = ctnSelectVal;
		}

		APP.Service.post(sendData, $body.find('[data-save-url]').val());

	}

	function saveNotificationSettings(e, key) {
		var sendData = {
			caid: $body.find('[data-caid]').val(),
			ctn: $body.find('[data-ctn]').val()
		};

		sendData[key] = $(e.target).prop('checked');
		APP.Service.post(sendData, $body.find('[data-save-notification]').val());
	}

	function addEmailValueDisable(e) {
		var $emailInput;

		if (e.target.name === 'tnhu_ctn_email') {
			$emailInput = $('[data-ref="email-input"]');
			$emailInput.attr('readonly', 'readonly');
			$emailInput.val('');
		}
	}
	function removeEmailValueDisable(e) {
		if (e.target.name === 'tnhu_ctn_email') {
			$('[data-ref="email-input"]').removeAttr('readonly');
		}
	}

	function handleEmailHelperDropdown(e) {
		if ($(e.target).attr('readonly') !== 'readonly') {
			$('[data-ref="email-input"]').siblings('.dropdown').attr('data-dropdown-menu', 'true');
		}
	}

	function consentSetDefaultEmail(e) {
		var $dropdown = $(e.target).parents('.dropdown'),
			$inputField = $dropdown.siblings('input[type="email"]'),
			email = $(e.target).attr('data-default-email');

		$inputField.val(email);
		$dropdown.attr('data-dropdown-menu', 'false');
	}

	function replaceAvatar(imageUrl) {
		var cacheBuster = Math.random() * 99999;

		$body.find('[data-profile-image]').css('background-image', 'url(' + imageUrl + '?' + cacheBuster + ')');
		$body.find('img.header__avatar, .mymenu-dropdown__header > img').attr('src', imageUrl + '?' + cacheBuster);
	}

	function profileChange(data) {
		if (data.isMigrationNeeded) {
			APP.Overlay.openWithTpl('migration-pass-overlay');
		}

		window.$element('profile-settings-nickname').text(data.name);
		window.$element('profile-settings-email').text(data.userName);
		$body.find('[data-simple="profile"]').addClass('hidden');
		$body.find('[data-edit="profile"]').addClass('hidden');
	}

	function emailRegisterCtn(event) {
		var $form = $body.find('[data-email-register-group]');

		if ($form.hasClass('block--display-none')) {
			$form.removeClass('block--display-none');
			event.preventDefault();
		}
	}

	function ctnSettings(data) {
		console.log(data);
		$body.find('[data-ctnsettings-name]')
			.text($body.find('[data-ctnsettings-name-input]').val())
			.attr('data-ctnsettings-name', $body.find('[data-ctnsettings-name-input]').val());
		$body.find('[data-ctnsettings-pw]').val('');
		APP.Layout.blockDisabler(null, 'data-ctnsetting-block');
	}

	function ctnSettingsReset() {
		$body.find('[data-ctnsettings-pw]').val('');
		$body.find('[data-ctnsettings-name-input]').val($body.find('[data-ctnsettings-name]').attr('data-ctnsettings-name'));
		$body.find('[data-ctnsettings-name]').parents('form').find('.sc-form__wrapper--show-error').removeClass('sc-form__wrapper--show-error');
	}

	function scrollToEmailConsent() {
		if (window.location.href.includes('target=email-consent')) {
			$('html, body').animate({
				scrollTop: $('#email-consent').offset().top + 100
			}, 2000);
		}
	}

	exports = {
		init: init,
		replaceAvatar: replaceAvatar,
		profileChange: profileChange,
		ctnSettings: ctnSettings,
		scrollToEmailConsent: scrollToEmailConsent
	};

	/* test-code */
	/* eslint no-underscore-dangle: 0 */
	exports.__testonly__ = {};
	/* end-test-code */

	return exports;

}());
